import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React, { useState } from "react";
import Slider from "react-slick";

import ProductCarouselImage from "~/components/ProductCarouselImage";

import "~/assets/css/slick.css";

const Wrapper = styled.div`
    .slick-slider {
        margin: ${({ withPadding }) => (withPadding ? `0 35px` : `0`)};

        @media (min-width: ${({ theme }) =>
                `${
                    theme.layout.maxContentWidthNumber +
                    2 * theme.layout.gutterNumber +
                    110
                }px`}) {
            margin: 0 25px;
        }
    }

    .slick-list {
        display: flex;
    }

    .slick-track {
        display: flex;
        justify-content: space-between;
    }

    .slick-initialized {
        width: 212px;
        margin: 0 auto;

        .slick-slide {
            display: block;
            height: 45px !important;
            width: 45px !important;
            margin-left: 5px;
            margin-right: 5px;

            & > div {
                height: 45px;
                width: 45px;
                overflow: hidden;
            }
        }
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
        max-width: 375px;
        margin: auto;
    }
`;

const ProductCarousel = ({
    products = [],
    carouselImageCount = 4,
    selectImage,
}) => {
    const numberOfSlides = products.length;
    const theme = useTheme();
    const [currentSlide, setCurrentSlide] = useState(0);
    const slidesToShow =
        carouselImageCount > numberOfSlides
            ? numberOfSlides
            : carouselImageCount;

    const sliderSettings = {
        slidesToShow: slidesToShow,
        variableWidth: true,
        infinite: true,
        speed: 0,
        arrows: false,
        responsive: [
            {
                breakpoint: theme.breakpointNumbers.mobileLandscape,
                settings: {
                    slidesToShow: 3 > numberOfSlides ? numberOfSlides : 3,
                },
            },
            {
                breakpoint: theme.breakpointNumbers.tabletLandscape,
                settings: {
                    slidesToShow: numberOfSlides >= 4 ? 4 : slidesToShow,
                },
            },
        ],
        beforeChange: (current, next) => {
            setCurrentSlide(next);
            selectImage(products[next].image);
        },
        focusOnSelect: true,
    };

    return (
        <Wrapper>
            <Slider {...sliderSettings}>
                {products.map(({ image }, index) => (
                    <ProductCarouselImage
                        key={`carousel_image-${index}`}
                        {...{
                            image,
                            selectImage,
                        }}
                        isActive={index === currentSlide}
                    />
                ))}
            </Slider>
        </Wrapper>
    );
};

ProductCarousel.propTypes = {
    products: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.shape({}),
            title: PropTypes.string,
            slug: PropTypes.string,
        }).isRequired,
    ).isRequired,
    carouselImageCount: PropTypes.number,
    selectImage: PropTypes.func.isRequired,
};

export default ProductCarousel;
